import { ITextButton } from './text.button.interface';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-text-button',
    templateUrl: './text.button.component.html',
    styleUrls: ['./text.button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextButtonSharedComponent {
    @Input() data: ITextButton;

    get getHref(): string {
        return (this.data.href) ? this.data.href : '#';
    }
}
